import { Definitions } from "imask/esm/masked/pattern";
import { forwardRef, RefCallback } from "react";
import { IMaskInput } from "react-imask";
import { InputBaseComponentProps } from "@mui/material/InputBase";

export interface TextMaskProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
  definitions: Definitions;
}

export const TextMaskCustom = forwardRef<
  HTMLInputElement,
  Omit<InputBaseComponentProps, "onChange"> & TextMaskProps
>(function TextMaskCustom(props, ref) {
  const { onChange, name, mask, definitions, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask={mask}
      definitions={definitions}
      inputRef={ref as RefCallback<HTMLTextAreaElement | HTMLInputElement>}
      // onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});
